import { gql } from "apollo-angular";

export const CUSTOMER_WITH_MINIMAL_IMPACT_NOTIFICATIONS_QUERY = gql`
  query CustomerWithMinimalImpactNotificationQuery($customerId: UUID!, $products: [String!]) {
    customerSubscriptions(customerId: $customerId, products: $products) {
      subscriptionId
      minimalImpactNotification
      description
      customerDescription
      product {
        type
      }
    }
  }
`;
